import ActionsPopover from "@/components/ActionsPopOver/ActionsPopOver";
import ActionsPopOverItem from "@/components/ActionsPopOver/ActionsPopOverItem";
import useTranslation from "@/hooks/useTranslation";
import {
  UniqueRouteLeg,
  useGetInboundTransportUniqueRoute,
  usePostInboundTransportRoute,
} from "@/hooks/useTransport";
import { message } from "antd";
import { TooltipPlacement } from "antd/es/tooltip";
import { ReactNode, useState } from "react";
import RouteWizard from "./RouteWizard";

export default function InboundRouteWizard({
  children,
  departureId,
  arrivalId,
  transportCategory,
  year,
  placement = "bottom",
}: {
  children: ReactNode;
  departureId: number;
  arrivalId: number;
  transportCategory: string;
  year?: number;
  placement?: TooltipPlacement;
}) {
  const saveMutation = usePostInboundTransportRoute();
  const [isOpen, setIsOpen] = useState(false);
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [forYear, setForYear] = useState(false);
  const t = useTranslation();

  const { data, isLoading } = useGetInboundTransportUniqueRoute({
    year: forYear ? year : undefined,
    departureId,
    arrivalId,
    transportCategory,
    enabled: isOpen,
  });

  const onSave = (route: UniqueRouteLeg[]) => {
    if (!year) return message.error(t.errors.general);

    saveMutation
      .mutateAsync({
        departure_facility_id: departureId,
        arrival_facility_id: arrivalId,
        transport_category: transportCategory,
        route: { route },
        ...(forYear ? { year } : {}),
      })
      .then(() => {
        setIsOpen(false);
      });
  };

  return (
    <>
      <ActionsPopover
        placement={placement}
        open={isPopoverOpen}
        onOpenChange={setIsPopoverOpen}
        zIndex={6}
        actions={
          <>
            <ActionsPopOverItem
              onClick={() => {
                setIsOpen(!isOpen);
                setForYear(false);
              }}
              black
            >
              Edit all
            </ActionsPopOverItem>
            {year && (
              <ActionsPopOverItem
                onClick={() => {
                  setIsOpen(!isOpen);
                  setForYear(true);
                }}
                black
              >
                Edit {year}
              </ActionsPopOverItem>
            )}
          </>
        }
      >
        {children}
      </ActionsPopover>
      {isOpen && (
        <RouteWizard
          loading={isLoading}
          onClose={() => setIsOpen(false)}
          route={data?.route}
          departure={data?.departure}
          arrival={data?.arrival}
          count={data?.total_count}
          isOpen={isOpen}
          arrivalType={"facility"}
          onSave={onSave}
          isSaving={saveMutation.isLoading}
        />
      )}
    </>
  );
}
